import { EmptyUploadColor as EmptyUploadColorIcon, Close as CloseIcon } from 'patternx-svg';
import { Button, message, Modal, Progress, Upload } from 'antd';
import { useRef, useState, useEffect } from 'react';
import styles from './index.module.less';
import { ExclamationCircleOutlined, SyncOutlined } from '@ant-design/icons';
import { IconFont } from '@/components';
import InfoCard from './components/InfoCard';
import { EventEmitter } from 'events';
import classNames from 'classnames';
import { useUpload } from '@/hooks';
import { addMaterial } from '@/services/source';
import { getUUID } from '@/utils/utils';

const { Dragger } = Upload;
const { confirm } = Modal;

const checkEventBus = new EventEmitter();
interface Props {
  categoryOptions: any[];
  onClose: () => void;
  onFinish: () => void;
  appOptions: any[];
  businessCategorys: any[];
}

const UploadMaterialModal: React.FC<Props> = (props: Props) => {
  const { categoryOptions, onClose, onFinish, appOptions, businessCategorys } = props;
  const [fileList, setFileList] = useState<any[]>([]);
  const [isInitStep, setIsInitStep] = useState(true);
  const uploadRef = useRef<any>(null);
  const [isSubmiting, setIsSubmiting] = useState(false);

  useEffect(() => {
    if (fileList.length > 0) {
      setIsInitStep(false);
    } else {
      setIsInitStep(true);
    }
  }, [fileList]);

  const handleDeleteClick = (uid: string) => {
    setFileList((v) => {
      return v.filter((f) => f.uid !== uid);
    });
  };
  const fileItemRender = (_originNode: any, file: any) => {
    return (
      <div className={styles.fileItemWrap}>
        <div
          className={classNames(styles.fileItem, {
            [styles.error]: file.status === 'error',
          })}
        >
          {!file.cmd5 ? (
            <IconFont className={styles.lfBtn} type="icon-fujian-xian" />
          ) : (
            <SyncOutlined spin className={styles.lfBtn} />
          )}
          <div
            className={`${styles.fileName} ${styles[file.status]}`}
            title={file.name || file.fileName}
          >
            {file.name || file.fileName}
          </div>
          <IconFont
            className={styles.rtBtn}
            type="icon-a-shanchu"
            onClick={() => {
              handleDeleteClick(file.uid);
            }}
          />
        </div>
        <div className={styles.fileState}>
          {file.status === 'uploading' && (
            <Progress
              strokeColor={{
                '0%': '#108ee9',
                '100%': '#87d068',
              }}
              strokeWidth={4}
              percent={parseInt(file.percent)}
              size="small"
            />
          )}
          {file.status === 'error' && (
            <div className={styles.errorStatus}>
              {/* <CloseCircleFilled style={{ color: '#ff4d4f', marginRight: 8 }} /> */}
              错误原因: {file.response?.message || '上传失败。发生未知错误，请重新上传'}
            </div>
          )}
        </div>
      </div>
    );
  };

  const { uploadRequest } = useUpload();

  const getBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const checkFileIsValid = (file: any) => {
    const fileName = file?.name?.toLowerCase();
    if (!fileName.endsWith('.png') && !fileName.endsWith('.jpg') && !fileName.endsWith('.jpeg')) {
      return false;
    }
    return true;
  };

  const uploadFile = (files: any, callback: Function) => {
    const fileName = getFileName(files.name);
    const fileSuffix = (files?.name?.split('.')?.pop() ?? 'png')?.toLowerCase();
    uploadRequest({
      url: '/boss/api/v1/material/public/file:upload',
      fileStream: files,
      appName: 'boss',
      fileName: `${fileName}.${fileSuffix}`,
      fileSuffix: fileSuffix,
      fullPath: '/test/',
      fileSize: files?.size,
      onPreload: () => {},
      onProgress: () => {},
      onSuccess: async (res: any) => {
        const { file, storage } = res ?? {};
        file.fileUrl = await getBase64(file);
        file.fileStorageId = storage?.storageFileId;
        file.status = 'done';
        file.percent = 100;
        file.length = 1000;
        file.width = 1000;
        file.appList = appOptions?.map((a) => a.value) || [];
        if (!file.uid) {
          file.uid = `new-file-${getUUID()}`;
        }
        callback?.(file);
      },
      onError: async (err: any) => {
        const { exists, file, storage } = err ?? {};
        if (exists) {
          file.fileUrl = await getBase64(file);
          file.fileStorageId = storage?.storageFileId;
          file.status = 'done';
          file.percent = 100;
          file.length = 1000;
          file.width = 1000;
          file.appList = appOptions?.map((a) => a.value) || [];
          if (!file.uid) {
            file.uid = `new-file-${getUUID()}`;
          }
          callback?.(file);
        }
      },
    });
  };

  const beforeUpload = async (file: any) => {
    if (!checkFileIsValid(file)) {
      return Upload.LIST_IGNORE;
    }
    console.log(file, '=============entry3');
    // file.fileName = file.name;
    // file.status = 'uploading';
    // file.percent = 0;
    // setFileList((v) => [...v, file]);
    uploadFile(file, (f: any) => {
      setFileList((v) => [...v, f]);
    });
    return true;
  };

  //文件名截取后缀之前的部分
  const getFileName = (name: string) => {
    const lowerName = name?.toLowerCase();
    const isIntercept =
      lowerName.endsWith('.png') || lowerName.endsWith('.jpg') || lowerName.endsWith('.jpeg');
    if (isIntercept) {
      return name?.slice(0, name?.lastIndexOf('.'));
    }
    return name;
  };

  const addAll = async () => {
    if (isSubmiting) {
      return;
    }
    // TODO: 检查必选填入信息
    const mList: any[] = [];
    for (let i = 0; i < fileList.length; i++) {
      const info = fileList[i];
      const materialName = info.materialName || info.name;
      const material = {
        name: getFileName(materialName),
        categoryId: info.categoryId,
        length: info.length,
        md5: info.md5,
        storageFileId: info.fileStorageId,
        appList: info.appList,
        width: info.width,
        businessCategoryIds: info?.businessCategoryId ? [info.businessCategoryId] : [],
      };

      if (!materialName) {
        message.error('未填写必填项');
        checkEventBus.emit('invalid', info.uid, 'name');
        return;
      }

      if (!info.categoryId) {
        message.error('未填写必填项');
        checkEventBus.emit('invalid', info.uid, 'categoryId');
        return;
      }
      if (!info.businessCategoryId) {
        message.error('未填写必填项');
        checkEventBus.emit('invalid', info.uid, 'businesscategoryId');
        return;
      }

      if (!info.length && info.length !== 0) {
        message.error('未填写必填项');
        checkEventBus.emit('invalid', info.uid, 'long');
        return;
      }

      if (!info.width && info.width !== 0) {
        message.error('未填写必填项');
        checkEventBus.emit('invalid', info.uid, 'width');
        return;
      }
      if (!info.appList || info.appList?.length === 0) {
        message.error('至少选择一个应用');
        checkEventBus.emit('invalid', info.uid, 'app');
        return;
      }
      if (info.length < 10 || info.length > 10000) {
        message.error('尺寸范围限制10-10000');
        checkEventBus.emit('invalid', info.uid, 'long');
        return;
      }
      if (info.width < 10 || info.width > 10000) {
        message.error('尺寸范围限制10-10000');
        checkEventBus.emit('invalid', info.uid, 'width');
        return;
      }
      mList.push(material);
    }
    setIsSubmiting(true);
    const res = await addMaterial({
      materialCreateList: mList,
    });
    setIsSubmiting(false);
    if (res?.success) {
      message.success('材质新增成功');
      onFinish();
      onClose();
    }
  };

  const onInfoNameChange = (info: any, name: string) => {
    setFileList((v) => {
      return v.map((information: any) => {
        if (information.uid === info.uid) {
          information.materialName = name;
        }
        return information;
      });
    });
  };
  const onInfoCategoryChange = (info: any, categoryId: string) => {
    setFileList((v) => {
      return v.map((information: any) => {
        if (information.uid === info.uid) {
          information.categoryId = categoryId;
        }
        return information;
      });
    });
  };

  const onInfoBusinessCategoryChange = (info: any, categoryId: string) => {
    setFileList((v) => {
      return v.map((information: any) => {
        if (information.uid === info.uid) {
          information.businessCategoryId = categoryId;
        }
        return information;
      });
    });
  };

  const onInfoAppChange = (info: any, app: string[]) => {
    setFileList((v) => {
      return v.map((information: any) => {
        if (information.uid === info.uid) {
          information.appList = app;
        }
        return information;
      });
    });
  };

  const onInfoLongChange = (info: any, long: number) => {
    setFileList((v) => {
      return v.map((information: any) => {
        if (information.uid === info.uid) {
          information.length = long;
        }
        return information;
      });
    });
  };

  const onInfoWidthChange = (info: any, width: number) => {
    setFileList((v) => {
      return v.map((information: any) => {
        if (information.uid === info.uid) {
          information.width = width;
        }
        return information;
      });
    });
  };

  const onInfoDelete = (uid: string) => {
    setFileList((v) => {
      return v.filter((f) => {
        return f.uid !== uid;
      });
    });
  };

  function addFilesFormDirectory(directory: any, path: string) {
    const dirReader = directory.createReader();
    const readEntries = function readEntries() {
      return dirReader.readEntries(function (entries: any[]) {
        entries.forEach(function (entry: any) {
          if (entry.isFile) {
            // 如果是文件
            entry.file(function (file: any) {
              file.fullPath = path + '/' + file.name;
              // 那么暴露出去的就是 '文件夹/q.jpg' 这种形式
              if (checkFileIsValid(file)) {
                uploadFile(file, (f: any) => {
                  setFileList((v) => [...v, f]);
                });
              }
            });
          } else if (entry.isDirectory) {
            // 递归处理
            addFilesFormDirectory(entry, path + '/' + entry.name);
          }
        });
      });
    };
    return readEntries();
  }
  const onFileDrop = (event: any) => {
    const files = Array.from(event?.dataTransfer?.files || []);

    if (files.length) {
      const items = event.dataTransfer?.items;
      if (items && items.length && items[0].webkitGetAsEntry) {
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          const entry = item.webkitGetAsEntry ? item.webkitGetAsEntry() : {};
          if (entry.isFile) {
            // 走正常添加文件
            // console.log(entry, '=============entry1');
            // entry.file(function (file: any) {
            //   console.log(file);
            // });
            //此处走了beforeUpload
          } else if (entry.isDirectory) {
            addFilesFormDirectory(entry, entry.name);
          }
        }
      }
    }
  };

  const _onClose = () => {
    if (fileList.length > 0) {
      confirm({
        title: '确认离开吗?',
        icon: <ExclamationCircleOutlined />,
        content: '已编辑的内容不会被保存',
        cancelText: '取消',
        okText: '确定',
        onOk: onClose,
        onCancel() {},
      });
    } else {
      onClose();
    }
  };

  const dragProps: any = {
    ref: uploadRef,
    accept: '.png,.jpg,.jpeg',
    // fileList: fileList,
    showUploadList: false,
    multiple: true,
    // itemRender: fileItemRender,
    beforeUpload: beforeUpload,
    onDrop: onFileDrop,
  };

  return (
    <Modal
      visible={true}
      footer={false}
      title="新增材质"
      maskClosable={false}
      onCancel={_onClose}
      width={600}
      wrapClassName={styles.modal}
      style={{ width: '600x' }}
      closeIcon={<CloseIcon size={24} />}
      bodyStyle={{ padding: 0, overflow: 'hidden' }}
    >
      <div className={`${styles.uploadWrap} ${!isInitStep ? styles.normal : ''}`}>
        <div className={styles.innerWrap}>
          <div style={{ margin: '0 24px' }}>
            {isInitStep ? (
              <div className={styles.info}>
                上传生成的材质png/jpg/jpeg文件，支持同时上传多个文件或文件夹。
              </div>
            ) : null}
            <Dragger {...dragProps}>
              {isInitStep ? (
                <div className={styles.initDescription}>
                  <div className={styles.icon}>
                    <EmptyUploadColorIcon size={120} />
                  </div>
                  <div className={styles.initTitle}>
                    点击<span>上传</span>或拖拽文件/文件夹到此区域上传
                  </div>
                  <div className={styles.supportZip}>支持格式：png/jpg/jpeg</div>
                </div>
              ) : (
                <div className={styles.dragDescription}>
                  <div className={styles.icon}>
                    <EmptyUploadColorIcon size={120} />
                  </div>
                  <div className={styles.dragRight}>
                    <div className={styles.dragTitle}>
                      点击<span>上传</span>或拖拽文件/文件夹到此区域上传
                    </div>
                    <div className={styles.dragInfo}>支持格式：png/jpg/jpeg</div>
                  </div>
                </div>
              )}
            </Dragger>
          </div>
          {isInitStep ? <div className={styles.initFooter}></div> : null}
          {!isInitStep ? (
            <div className={styles.info}>
              <div className={styles.infoCardList}>
                {fileList.map((info: any) => {
                  return (
                    <InfoCard
                      key={info.uid}
                      info={info}
                      categoryOptions={categoryOptions}
                      businessCategorys={businessCategorys}
                      eventBus={checkEventBus}
                      appOptions={appOptions}
                      onDelete={onInfoDelete}
                      onNameChange={(name: string) => {
                        onInfoNameChange(info, name);
                      }}
                      onCategoryChange={(cateforyId: string) => {
                        onInfoCategoryChange(info, cateforyId);
                      }}
                      onAppChange={(app: string[]) => {
                        onInfoAppChange(info, app);
                      }}
                      onLongChange={(long: number) => {
                        onInfoLongChange(info, long);
                      }}
                      onWidthChange={(width: number) => {
                        onInfoWidthChange(info, width);
                      }}
                      onBusinessCategoryChange={(cateforyId: string) => {
                        onInfoBusinessCategoryChange(info, cateforyId);
                      }}
                    />
                  );
                })}
              </div>
            </div>
          ) : null}
        </div>
        {!isInitStep ? (
          <div className={styles.footer}>
            <div className={styles.footerLeft}></div>
            <div className={styles.footerRight}>
              <Button onClick={_onClose}>取消</Button>
              <Button
                type="primary"
                disabled={fileList.length < 1}
                onClick={addAll}
                style={{ marginLeft: 8 }}
              >
                确定
              </Button>
            </div>
          </div>
        ) : null}
      </div>
    </Modal>
  );
};

export default UploadMaterialModal;
